import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-view-announcement',
  templateUrl: './single-view-announcement.component.html',
  styleUrls: ['./single-view-announcement.component.css']
})
export class SingleViewAnnouncementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
